(() => {
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const menu = q('#MazayaMobileMenu');
  const menuOpen = q('[data-mz-menu-open]');
  const menuClose = q('[data-mz-menu-close]');
  let lastFocus = null;

  const closeMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    document.body.classList.remove('menu-open');
    menuOpen?.setAttribute('aria-expanded', 'false');
    lastFocus?.focus();
  };
  const openMenu = () => {
    if (!menu) return;
    lastFocus = document.activeElement;
    menu.hidden = false;
    document.body.classList.add('menu-open');
    menuOpen?.setAttribute('aria-expanded', 'true');
    menuClose?.focus();
  };
  menuOpen?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menu?.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu && !menu.hidden) closeMenu();
  });

  qa('.search-drawer-button').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      window.setTimeout(() => q('#SearchDrawer input[type="search"]')?.focus(), 300);
    });
  });

  qa('[data-mz-gallery]').forEach((gallery) => {
    const slides = qa('[data-mz-slide]', gallery);
    const thumbs = qa('[data-mz-thumb]', gallery);
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.mzThumb;
        slides.forEach((slide) => {
          const active = slide.dataset.mzSlide === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });

  qa('[data-mz-quantity]').forEach((quantity) => {
    const input = q('input', quantity);
    q('[data-mz-qty-minus]', quantity)?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    q('[data-mz-qty-plus]', quantity)?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  qa('[data-mz-product]').forEach((product) => {
    const variants = qa('[data-mz-variant-input]', product);
    const price = q('[data-mz-product-price]', product);
    const availability = q('[data-mz-product-availability]', product);
    const submit = q('.mz-product-form__submit', product);
    const submitText = submit ? q('span', submit) : null;
    const selectVariant = (selected) => {
      if (!selected) return;
      const isAvailable = selected.dataset.available !== 'false' && !selected.disabled;
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (availability) {
        availability.textContent = isAvailable ? 'En stock' : 'Épuisé';
        availability.classList.toggle('is-unavailable', !isAvailable);
      }
      if (submit) submit.disabled = !isAvailable;
      if (submitText) submitText.textContent = isAvailable ? 'Ajouter au panier' : 'Épuisé';
      if (selected.dataset.mediaId) {
        const gallery = q('[data-mz-gallery]', product);
        const mediaThumb = gallery ? q(`[data-mz-thumb][data-mz-media-id="${selected.dataset.mediaId}"]`, gallery) : null;
        mediaThumb?.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url);
    };
    variants.forEach((variant) => variant.addEventListener('change', () => selectVariant(variant)));
    selectVariant(q('[data-mz-variant-input]:checked', product));
  });

  qa('[data-mz-faq]').forEach((faq) => {
    const children = Array.from(faq.children);
    const fragment = document.createDocumentFragment();
    let details = null;
    let answer = null;
    children.forEach((node) => {
      if (node.tagName === 'H2') {
        details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = node.textContent;
        answer = document.createElement('div');
        answer.className = 'mz-faq__answer';
        details.append(summary, answer);
        fragment.append(details);
      } else if (details && answer) {
        answer.append(node);
      } else {
        fragment.append(node);
      }
    });
    faq.replaceChildren(fragment);
  });
})();
